<template>
<nav aria-label="breadcrumb" class="breadcrumb-area">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">利用規約</li>
  </ol>
</nav>
  <div class="container">

      <div class="top--section">
          <Rule/>
      </div>
  </div>
</template>
<script setup>
import Rule from "@/components/Static/Rule.vue";
</script>
